import {IEcologyLayerInformation} from '../interfaces/store';
import {toLonLat} from 'ol/proj';

/**
 * Load the ecology layer info
 */
export default function({
  bounds,
  layers,
  x,
  y,
  width,
  height
}): Promise<IEcologyLayerInformation> {
  return new Promise((resolve, reject): void => {
    const params = [
      'SERVICE=WMS',
      'VERSION=1.1.1',
      'REQUEST=GetFeatureInfo',
      'FORMAT=image/png',
      'TRANSPARENT=true',
      `QUERY_LAYERS=${layers}`,
      'STYLES',
      `LAYERS=${layers}`,
      'INFO_FORMAT=application/json',
      'FEATURE_COUNT=50',
      `X=${parseInt(x)}`,
      `Y=${parseInt(y)}`,
      'SRS=EPSG:4326',
      `WIDTH=${parseInt(width)}`,
      `HEIGHT=${parseInt(height)}`,
      `BBOX=${bounds[0]},${bounds[1]},${bounds[2]},${bounds[3]}`
    ];

    const url = `https://projektcheck.gs.ils-geomonitoring.de/projektcheck/wms?${params.join(
      '&'
    )}`;

    fetch(url)
      .then(response => response.json())
      .then(data => resolve(data))
      .catch(error => reject(error));
  });
}
